//IMPORTAÇÃO DAS BIBLIOTECAS---------------------------------------------------
import { useState } from "react";
import { useTranslation } from 'react-i18next';



//IMPORTAÇÃO DOS COMPONENTES---------------------------------------------------
import styles from "./preferencias.module.css";
import { setThemeColorByTheme, applyThemeClass, applyColorTheme } from '../../../../../theme.js';
import { api } from '../../../../../services/api.js';



//COMPONENTE-------------------------------------------------------------------
export default function Preferencias() {
    //variáveis e estados

    // idiomas
    const { t } = useTranslation();

    // estados para tema e cor do tema
    const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'sistema');
    const [colorTheme, setColorTheme] = useState(() => localStorage.getItem('colorTheme') || 'azul');

    //função para modificar linguagem
    const { i18n } = useTranslation();
    const changeLanguage = async (lang) => {
        try {
            i18n.changeLanguage(lang);
            localStorage.setItem('appLanguage', lang); // salva escolha
            // salva no backend se o usuário estiver logado
            await api.post('/auth/user/setLanguage', { language: lang });
            // console.log(response.data.msg); // para desenvolvimento
        } catch (error) {
            console.error('Erro ao alterar a linguagem:', error);
        }
    };


    //função para modificar tema
    function handleThemeChange(event) {
        setTheme(event.target.value);
        localStorage.setItem('theme', event.target.value);
        applyThemeClass(); // Atualiza imediatamente o tema na pagina - // chamada também em App.js
        setThemeColorByTheme(); // Atualiza imediatamente o tema no navegador - // chamada também em App.js
    }

    //função para modificar cor do tema
    function handleColorThemeChange(event) {
        setColorTheme(event.target.value);
        localStorage.setItem('colorTheme', event.target.value);

        applyColorTheme(); // Atualiza imediatamente a cor do tema - // chamada também em App.js
        setThemeColorByTheme(); // Atualiza imediatamente o tema no navegador - // chamada também em App.js
    }

    //html do componente
    return (
        <>
            <span className={styles.themeLabel}>{t("Example of an application theme")}</span>
            <div className={styles.exemploTema}>
                <div className={styles.exemploHeader}>
                    <span className={styles.exemploPonto}></span>
                    <span className={styles.exemploPonto}></span>
                    <span className={styles.exemploPonto}></span>
                </div>
                <div className={styles.exemploCorpo}>
                    <div className={styles.exemploLinha}></div>
                    <div className={styles.exemploLinha}></div>
                    <div className={styles.exemploBotao}></div>
                </div>
            </div>

            {/* tema do aplicativo */}
            <form className={styles.preferencesForm}>
                <div className={styles.themeGroup}>
                    <span className={styles.themeLabel}>{t("Theme of the application")}</span>
                    <div className={styles.themeOptions}>
                        <label className={`${styles.themeOption} ${theme === "claro" ? styles.selected : ""}`}>
                            <input
                                type="radio"
                                name="theme"
                                value="claro"
                                checked={theme === "claro"}
                                onChange={handleThemeChange}
                            />
                            {t("Light")}
                        </label>
                        <label className={`${styles.themeOption} ${theme === "escuro" ? styles.selected : ""}`}>
                            <input
                                type="radio"
                                name="theme"
                                value="escuro"
                                checked={theme === "escuro"}
                                onChange={handleThemeChange}
                            />
                            {t("Dark")}
                        </label>
                        <label className={`${styles.themeOption} ${theme === "sistema" ? styles.selected : ""}`}>
                            <input
                                type="radio"
                                name="theme"
                                value="sistema"
                                checked={theme === "sistema"}
                                onChange={handleThemeChange}
                            />
                            {t("System")}
                        </label>
                    </div>
                    <span className={styles.themeHint}>
                        {t("Choose how the application will be displayed for you.")}
                    </span>
                </div>
            </form>

            {/* cor do aplicativo */}
            <form className={styles.preferencesForm}>
                <div className={styles.themeGroup}>
                    <span className={styles.themeLabel}>{t("Color of the application")}</span>
                    <div className={styles.themeOptions}>
                        <label className={`${styles.themeOption} ${colorTheme === "azul" ? styles.selected : ""}`}>
                            <input
                                type="radio"
                                name="colorTheme"
                                value="azul"
                                checked={colorTheme === "azul"}
                                onChange={handleColorThemeChange}
                            />
                            {t("Blue")}
                        </label>
                        <label className={`${styles.themeOption} ${colorTheme === "verde" ? styles.selected : ""}`}>
                            <input
                                type="radio"
                                name="colorTheme"
                                value="verde"
                                checked={colorTheme === "verde"}
                                onChange={handleColorThemeChange}
                            />
                            {t("Green")}
                        </label>
                        <label className={`${styles.themeOption} ${colorTheme === "rosa" ? styles.selected : ""}`}>
                            <input
                                type="radio"
                                name="colorTheme"
                                value="rosa"
                                checked={colorTheme === "rosa"}
                                onChange={handleColorThemeChange}
                            />
                            {t("Pink")}
                        </label>
                    </div>
                    <span className={styles.themeHint}>
                        {t("Choose the main color of the application theme.")}
                    </span>
                </div>
            </form>

            {/* linguagem do aplicativo */}
            <form className={styles.preferencesForm}>
                <div className={styles.themeGroup}>
                    <span className={styles.themeLabel}>{t("Language of the application")}</span>
                    <div className={styles.themeOptions}>
                        <select
                            value={i18n.language}
                            onChange={(e) => changeLanguage(e.target.value)}
                            style={{
                                padding: '6px 10px',
                                borderRadius: '6px',
                                border: '1px solid #ccc',
                                backgroundColor: '#f9f9f9',
                                fontSize: '0.9rem',
                                cursor: 'pointer'
                            }}
                        >
                            <option value="pt">🇵🇹 Português</option>
                            <option value="pt-BR">🇧🇷 Português (Brasil)</option>
                            <option value="en">🇬🇧 English</option>
                            <option value="en-US">🇺🇸 English (USA)</option>
                            <option value="es">🇲🇽 Español</option>
                            <option value="es-ES">🇪🇸 Español (España)</option>

                        </select>
                    </div>
                    <span className={styles.themeHint}>
                        {t("Choose the language in which the application will be displayed.")}
                    </span>
                </div>
            </form>



        </>
    );
}